export default {
    sessionApiUrl: 'https://session-api.mysoluto.com/v1',
    expertQueuesApiUrl: 'https://expert-queue-api.mysoluto.com/v1',
    liveQueueApiUrl: 'https://live-queue-api.mysoluto.com',
};
